<div class="row h-100 ">
  <div class="col-md-12 my-auto">
<div class="row justify-content-center">
  <div class="col-md-3">
      <div class="card">
        <div class="content-body">
<h2 class="h4 mt-0 mb-1">Forgot Password?</h2>
<p [tcColor]="'#8f8f90'">We will send you password</p>

<forgot-form></forgot-form>
</div>
</div>

</div>
</div>
</div>
</div>